import { render, staticRenderFns } from "./ruleRange.vue?vue&type=template&id=fedb7440&scoped=true"
import script from "./ruleRange.vue?vue&type=script&lang=js"
export * from "./ruleRange.vue?vue&type=script&lang=js"
import style0 from "./ruleRange.vue?vue&type=style&index=0&id=fedb7440&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedb7440",
  null
  
)

export default component.exports